var poll_default = {
  "fontElementMap": "_0SS4W",
  "container": "scMOU",
  "fullscreen": "lHoos",
  "background_overlay": "NM4jW",
  "with_image": "YEHr-",
  "options": "GgfQZ",
  "webview": "mVJrb",
  "grid": "hKJpK",
  "option": "gERfk",
  "cta_button": "MJweP",
  "add_option": "spCAP",
  "see_more": "ooOs6",
  "list": "_4Ju-E",
  "column": "ha3mR",
  "additional_note": "DiMx2",
  "spinner": "tzyik",
  "spin": "_16IUV",
  "shown": "_6FpyQ",
  "error": "WcY8v"
};
export {
  poll_default as default
};
//# sourceMappingURL=poll-scss.js.map
